<app-navbar-style-two></app-navbar-style-two>

<div class="inner-banner">
  <div class="container">
    <div class="inner-title text-end">
      <!-- <ul>
        <li><a routerLink="/">Home</a></li>
        <li><i class='bx bx-chevron-right'></i></li>
        <li>Products</li>
      </ul> -->
      <h2>UNIKAI Products</h2>
      <h3>Refreshment You Can Trust. A vibrant selection of delicious products, crafted to bring natural flavor, nourishment and joyful freshness.</h3>
    </div>
  </div>
</div>

<div class="product-area pt-100 pb-70">
  <div class="container">
    <div class="row" *ngIf="!loading">
      <div class="col-lg-4 col-md-6" *ngFor="let product of products">
        <div class="product-card">
          <a (click)="viewProduct(product.slugs)" style="cursor: pointer;">
            <img [src]="getImg(product?.image_url)" [alt]="product?.name">
          </a>
          <div class="product-content">
            <ul class="rating">
              <li>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star-half'></i>
              </li>
            </ul>
            <a (click)="viewProduct(product.slugs)" style="cursor: pointer;">
              <h3>{{ product?.name }}</h3>
            </a>
            <p class="product-description">{{ product?.short_description || product?.description }}</p>
            <div class="product-info">
              <p><strong>Brand:</strong> {{ product?.brand?.name }}</p>
              <p><strong>Size:</strong> {{ product?.pack_size_name }} ml</p>
            </div>
            <a (click)="viewProduct(product.slugs)" class="default-btn product-btn" style="cursor: pointer;">
              <i class='bx bx-show'></i> View More
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="loading" *ngIf="loading">
      <p>Loading products...</p>
    </div>

    <div class="no-products" *ngIf="!loading && products.length === 0">
      <p>No products available.</p>
    </div>
  </div>
</div>

<app-footer-style-one></app-footer-style-one>
